import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import './Menu.scss';
import './callout.scss';
import SubmenuList from './SubmenuList';


const Menu = (props) => {
    let menuList = [...props.menuSubmenu];
    let productTypeMenu = [];
    let QRSupport = props.QRSupport;
    let {QR, ReduceTransitions} = {...props.ui};
    let onLoadActiveAccordionMobile = props.onLoadActiveAccordionMobile;
    // let isMobIsipadIsPotrait = window.deviceBasedonBodyClass == 'ipadDesktopPortrait' || window.deviceBasedonBodyClass == 'mobilePortrait' || window.deviceBasedonBodyClass =='ipadPortrait'  || window.deviceBasedonBodyClass =='androidTabPortrait';;

    let filterMenuBasedOnConfigType = props.filterMenuBasedOnConfigType;

    /*for calculating width of HTML element this block is used*/
    let cssVariableValues = props.cssVariableValues;
    let accordionMenuTextWidth = parseInt(cssVariableValues.menuWidth) - (parseInt(cssVariableValues.accordionMenuPaddingLeft) + parseInt(cssVariableValues.accordionMenuPaddingRight) + parseInt(cssVariableValues.accordionMenuIconWidth) + parseInt(cssVariableValues.accordionMenuIconMarginLeft) + parseInt(cssVariableValues.accordionMenuIconMarginRight) + parseInt(cssVariableValues.accordionMenuChevronWidth) + parseInt(cssVariableValues.accordionMenuChevronMarginLeft))
    let qrTextWidth = parseInt(cssVariableValues.menuWidth) - (parseInt(cssVariableValues.menuFooterPaddingLeftRight)*2);
    // console.log('accordionMenuTextWidth ', accordionMenuTextWidth);
    // console.log('qrTextWidth ', qrTextWidth);

    let qrTextContentwidth=props.calcHtmlElementNoWrapWidth(QR, cssVariableValues.qrTextFontSize);
    // console.log('qrTextmaxwidth ', qrTextContentwidth);
    let adjuestedWidth = window.UiUtils.checkIfWidthNeedUpdate(qrTextContentwidth, qrTextWidth, cssVariableValues.qrTextFontSize);
    // let qrTextStyle={width:'+adjuestedWidth !== 0 ? adjuestedWidth+'px' : ''}
    /*for calculating width of HTML element this block is used*/
    
    if(window.isMobIsipadIsPotrait){
        menuList = menuList.filter(list => list.id != "ProductType");
        productTypeMenu = props.menuSubmenu.filter(list => list.id == "ProductType");
    }
    if(productTypeMenu.length == 1) productTypeMenu = productTypeMenu[0];
    // console.log('isMobIsipadIsPotrait menuList ', menuList);
    // console.log('isMobIsipadIsPotrait productTypeMenu ', productTypeMenu);
    
    const handleTransitions = (e) => {
      const isChecked = window.UiUtils.domElement.animSwitchValue.checked;

      console.log('handleTransitions isChecked ', isChecked);
      if (isChecked === true) {
         window.animationStatus = 'off';
         window.UiUtils.domElement.animswtich.setAttribute('aria-checked', 'true');
        //  window.UiUtils.domElement.animSwitchValue.checked = false;
        //  window.UiUtils.updateAriaLabel('handleTransitions', window.UiUtils.domElement.animswtich, "checked");

      } else {
         window.animationStatus = 'on';
         window.UiUtils.domElement.animswtich.setAttribute('aria-checked', 'false');
            // window.UiUtils.domElement.animSwitchValue.checked = true;
        //  window.UiUtils.updateAriaLabel('handleTransitions', window.UiUtils.domElement.animswtich, "not checked");

      }
      setTimeout(function(){
          window.UiUtils.setFocusOnElement(window.UiUtils.domElement.animswtich);
      }, 300);
   }
   const handleTransitionskeyPress = (e) => {
    if(e.type === "keydown" && e.key === "Enter") {
        window.UiUtils.domElement.animSwitchValue.checked = !window.UiUtils.domElement.animSwitchValue.checked;
        handleTransitions(e);
    }
    //   const isChecked = window.UiUtils.domElement.animSwitchValue.checked;

    //   if (isChecked === true) {
    //      window.animationStatus = 'on';
    //      window.UiUtils.domElement.animSwitchValue.checked = false;
    //     //  window.UiUtils.updateAriaLabel('handleTransitions', window.UiUtils.domElement.animswtich, "")
    //   } else {
    //      window.animationStatus = 'off';
    //      window.UiUtils.domElement.animSwitchValue.checked = true;
    //     //  window.UiUtils.updateAriaLabel('handleTransitions', window.UiUtils.domElement.animswtich, "")

    //   }
      
    //  window.UiUtils.setFocusOnElement(window.UiUtils.domElement.animswtich);
    //   window.UiUtils.setFocusOnElement(document.getElementById("animswtich"));
   }

    // Changes for QR code update
        if (window.location.href) {
           let url = window.location.href.split('?')[0];
           if (!url.endsWith('index.html')) {
           if (!url.endsWith('/')) url += '/';
               url += 'index.html';
        }
        let params = window.location.href.split('?')[1];
        let newParames = '?qr=1';
        if(params != undefined && !params.includes('qr=')){
            newParames = newParames+'&'+params;
        } else if(params != undefined && params.includes('qr=')){
            newParames = '?'+params;
        }

        url = url+newParames;

        /*Code for Content qr */
        if(params != undefined && params.includes('contentURL=')){
            let contentURL = params.split('contentURL=')[1];
            url = contentURL+'?qr=1';
        }
        /*Code for Content qr End*/
        

        
        
        /*Code for Content qr end */

        // if(window.ContentURLforQR != )

        window.linkForGenerateQR = `${url}`;
    }
    

    let filteredMenuList = menuList.filter(filterMenuBasedOnConfigType);

    let accordionUpdated = false;
    if(window.selectedConfig['menuList'] && window.selectedConfig['menuList'].length != undefined && window.selectedConfig['menuList'].length !== filteredMenuList.length){
        accordionUpdated = true;
    }

    window.selectedConfig['menuList'] = [...filteredMenuList];
    window.config.nextPrevArray = [];
    // console.log('menu called.... ', window.selectedConfig)
    window.menuSubmenuTabindex = 6; // how to use have tab index till 6 so menu submenu and reduce tarnsition and footer controls will have index after that and will be calculated with this variable 
    let menuIndex = window.menuSubmenuTabindex;
    return (
        <>
            <nav id='mainMenu' className='menuContainer expanded'>
                {/* Product type btn for mobile*/}
                {productTypeMenu.length == undefined && window.isMobIsipadIsPotrait && 
                <div className='productTypeBtn'>
                    <img className='icon' src={productTypeMenu.iconMobile} />
                    <span className='productTypeMenuTitle'>{productTypeMenu.mobileTitle}</span>
                    <ul className='productTypeList'>
                        {productTypeMenu.items.map((item) => {
                            let isActive = (window.selectedConfig[item.featureType] == item.id);
                            // console.log('isActive productTypeList item.featureType', item.featureType)
                            // console.log('isActive productTypeList window.selectedConfig', window.selectedConfig)
                            // console.log('isActive productTypeList window.selectedConfig[item.featureType]', window.selectedConfig[item.featureType])
                            // console.log('isActive productTypeList item.id', item.id)
                            // console.log('isActive productTypeList ', isActive)
                            return (
                                <li key={item.id} className="subMenuBtn radioButton mob" id={`menu_id_${item.id}`} onClick={e => props.handleSubMenuClick(item, e)}>
                                    <label>  <input type="radio" name={item.radioName} value={item.id} defaultChecked={isActive} /></label>
                                    <span className='mobRadioTitle'>  {item.mobileTitle} </span>
                                </li>
                                
                            )
                        })}
                    </ul>
                    
                </div>
                }
                {/* Product type btn for mobile end*/}
                <ul>
                    {
                        
                        filteredMenuList.filter(filterMenuBasedOnConfigType).map((list, listIndex) => {
                            
                            /*Code to check configType of main accordion and show/hide the menu based on configType if any*/
                            // console.log('props.isFirstAccordion ', props.isFirstAccordion)
                            let isFirstAccordion = props.isFirstAccordion;
                            // console.log('isFirstAccordion ', isFirstAccordion)
                            // if(window.selectedConfig.hasOwnProperty['selectedAccordion']){

                                // console.log('window.selectedConfig ', window.selectedConfig.selectedAccordion)
                            // }

                            let isAccordionActive = (isFirstAccordion && window.isMobIsipadIsPotrait && listIndex == 0) || (!isFirstAccordion && window.isMobIsipadIsPotrait && listIndex == 0 && window.selectedConfig.selectedAccordion === undefined) || (!isFirstAccordion && window.selectedConfig.selectedAccordion !== undefined && window.selectedConfig.selectedAccordion.includes("accordion_"+list.id));
                            // let isAccordionActive = window.isMobIsipadIsPotrait && window.selectedConfig.selectedAccordion && window.selectedConfig.selectedAccordion.includes("accordion_" + list.id);
                            // let isAccordionActive = window.selectedConfig.selectedAccordion && window.selectedConfig.selectedAccordion.includes("accordion_" + list.id);
                            // let isAccordionActive = Array.isArray(window.selectedConfig.selectedAccordion) && window.selectedConfig.selectedAccordion.includes("accordion_" + list.id); //@DS
                            // if(window.selectedConfig.selectedAccordion){
                            //     console.log('Menu called .... isFirstAccordion ', isFirstAccordion)
                            //     console.log('Menu called .... window.selectedConfig.selectedAccordion ', window.selectedConfig.selectedAccordion !== undefined)
                            //     console.log('Menu called .... window.selectedConfig.selectedAccordion ', window.selectedConfig.selectedAccordion)
                            //     // if(list.id == "positionView"){
                            //     //     console.log('Menu called .... positionView should be active ')
                            //     // }
                            //     console.log('Menu called .... list.id ', list.id)
                            //     console.log('Menu called .... window.selectedConfig.selectedAccordion.includes("accordion_"+list.id) ', window.selectedConfig.selectedAccordion.includes("accordion_"+list.id))
                            //     console.log('Menu called .... isAccordionActive ', isAccordionActive)
                                
                            // }
                            if (window.isMobIsipadIsPotrait && listIndex === 0 && window.selectedConfig.selectedAccordion === undefined && onLoadActiveAccordionMobile && onLoadActiveAccordionMobile.includes(list.id)) {  //setting index 0 active all time @DS
                                // if (window.isMobIsipadIsPotrait && window.selectedConfig.selectedAccordion === undefined && onLoadActiveAccordionMobile && list.id === onLoadActiveAccordionMobile) { // add this to set active accordion pass from json
                                // console.log('Menu called .... onLoadActiveAccordionMobile ', onLoadActiveAccordionMobile) 
                                // console.log('Menu called .... listIndex ', listIndex)
                                // console.log('Menu called .... window.selectedConfig.selectedAccordion ', window.selectedConfig.selectedAccordion)
                                // console.log('Menu called .... isFirstAccordion ', isFirstAccordion)
                                // console.log('Menu called .... isAccordionActive ', isAccordionActive)
                                window.selectedConfig.selectedAccordion = ["accordion_" + list.id];
                            } else if (window.isMobIsipadIsPotrait && window.selectedConfig.selectedAccordion !== undefined && isFirstAccordion) {
                                const firstAccordionId = 'accordion_' + filteredMenuList[0].id;
                                window.selectedConfig.selectedAccordion = [firstAccordionId];
                            }
                            
                            // if(isFirstAccordion && window.isMobIsipadIsPotrait){
                            //     const firstAccordionId = 'accordion_' + filteredMenuList[0].id;
                            //     window.selectedConfig.selectedAccordion = [firstAccordionId];
                            // }
                            //     // here we update the window.selectedConfig.selectedAccordion to select first accordion
                                //  if (window.isMobIsipadIsPotrait && filteredMenuList.length > 0 ) {
                                //     const firstAccordionId = 'accordion_' + filteredMenuList[0].id;
                                //     window.selectedConfig.selectedAccordion = [firstAccordionId];
                                //  }
                            // }
                         
                            // if(listIndex == 0) {
                                // isFirstAccordion = true;
                            // } else {

                                // if(accordionUpdated && window.isMobIsipadIsPotrait && document.querySelector('.accordionMenu.active')) document.querySelector('.accordionMenu.active').classList.remove('active');
                            // }
                            

                            let submenuIndex = listIndex === 0 ? 1 : filteredMenuList[listIndex-1].items.length;
                            // if(listIndex !== 0 )
                            // console.log('filteredMenuList[listIndex-1].items.length ', filteredMenuList[listIndex-1].items.length)

                            // console.log('submenuIndex ', submenuIndex)

                            menuIndex += 1+submenuIndex;
                            window.menuSubmenuTabindex = menuIndex;
                            // window.menuSubmenuTabindex += menuIndex;
                            // window.menuSubmenuTabindex += submenuIndex;/*How to use component has tabIndex till 6 so Menu tabIndex will start from 7*/
                             
                            // console.log('menuIndex ', menuIndex)
                            // console.log('list.items.length ', list.items.length)
                            if(listIndex === filteredMenuList.length-1) window.menuSubmenuTabindex = menuIndex + list.items.length;
                            // console.log('window.menuSubmenuTabindex ', window.menuSubmenuTabindex)
                            let accordionKey = list.id;
                            if(window.isMobIsipadIsPotrait){
                                accordionKey = Math.random();
                            }

                            return (
                                <React.Fragment key={list.id}>
                                    {
                                        // <li id={"accordion_"+list.id} role="button" className={(isFirstAccordion && isMobIsipadIsPotrait) ? "accordionMenu active" : "accordionMenu"} onClick={() => props.accordionMenuclick(list, "accordion_"+list.id)} onKeyDown={(e) => {
                                        <li key={accordionKey} tabIndex={-1} data-tabindex={1} id={"accordion_"+list.id} role="button" aria-expanded="false" className={(isAccordionActive) ? "accordionMenu active" : "accordionMenu"} onClick={() => props.accordionMenuclick(list, "accordion_"+list.id)} onKeyDown={(e) => {
                                                if (e.key !== 'Enter') {
                                                return
                                                } props.accordionMenuclick(list, "accordion_"+list.id)
                                            }}>
                                        <img className="icon" src={list.icon} />
                                        <span className="text" data-width={accordionMenuTextWidth} data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, cssVariableValues.accordionMenuTextFontSize)}>{!window.isMobIsipadIsPotrait ? list.title : list.mobileTitle} </span> 
                                        <svg viewBox="0 0 32 32" className="chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg>
                                    </li>}

                                    {(list.items) && 
                                        <SubmenuList count={props.count}  accordionId={"accordion_"+list.id} parentIndex={menuIndex} accordionMenu={list} handleSubMenuClick={props.handleSubMenuClick} filterMenuBasedOnConfigType={filterMenuBasedOnConfigType} calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth} cssVariableValues={cssVariableValues} />
                                        }

                                </React.Fragment>
                            )
                            
                        })
                    }
                </ul>
                {/*Menu Footer */}
                    <div className='menuFooter'>
                        {(!window.isMobIsipadIsPotrait && !window.isIpadOrIphoneforAr && !window.isAndroidTab && QRSupport) && 
                            <div className='qrContainer'>
                                {/* <img className='qrImage' src='images/qrcode.svg' aria-label='qr code image' /> <br /> */}
                                <QRCode
                                    size={130}
                                    value={window.linkForGenerateQR}
                                    style={{height:"auto"}}
                                    className='qrImage'
                                    aria-hidden="true"
                                    />
                                <span className='text' style={{width: adjuestedWidth !== 0 ? adjuestedWidth+'px' : ''}}  data-contentwidth={props.calcHtmlElementNoWrapWidth(QR, cssVariableValues.qrTextFontSize)}> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                            </div>
                        }
                        <div className='reduceTransitions' id="animation">
                            <span aria-hidden="true" id="reduceTransitionsText">{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                            <label className="switch" tabIndex="-1" data-tabindex={1} id="animswtich" onKeyDownCapture={handleTransitionskeyPress}  role='switch' aria-label={"Reduce Transitions"} >
                                <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={false}  aria-checked={false} />
                                <span className="tabIndexStyle slider round" ></span>
                                <span className="onOff"></span>
                            </label>
                        </div>
                    </div>
                {/*Menu Footer End */}
                
            </nav>
            
        </>
    )
}

export default Menu;